module.exports = __webpack_public_path__ + "static/img/footer1.5e3463b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/footer1.jpg
// module id = 9Q4M
// module chunks = 9